import React from 'react';
import DataTables from '../../CommonDataTable/DataTable';
import config from '../../../../config/config';
import apiCalls from '../../../../config/apiCalls'
import ViewModal from '../../CommonModals/viewModal';
import NewUserModal from '../../CommonModals/NewUserModal';
import showToasterMessage from '../../../UI/ToasterMessage/toasterMessage';

import fetchMethodRequest from "../../../../config/service"
import FormModal from '../../../Form/FormModal';
import store from '../../../App/store';
import filePath from "../../../../config/configSampleFiles";

import RolePermissions from '../../CommonModals/Permissions';
import * as moment from 'moment';
// config file
export default class Teachers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languageData: '',
      rolePermission: "",
      editSelectedRecord:window.location.href.includes("edit"),
      addSelectedRecord:window.location.href.includes("create"),
      viewSelectedRecord:window.location.href.includes("view"),	
    };
  }

  static getDerivedStateFromProps(props, state) {
    let storeData = store.getState()
    let languageData = storeData && storeData.settingsData && storeData.settingsData.settings && storeData.settingsData.settings.languageTranslation ? storeData.settingsData.settings.languageTranslation : ""
    return { languageData: languageData };
  }
  componentDidMount = () => {
    //Screen permisions value can be edit,view, no view
    let screenPermissions = RolePermissions.screenPermissions('Slots');
    if (screenPermissions) {
      this.setState({
        rolePermission: screenPermissions
      })
    }
  }
  setData = (props) => {
    let rowData = {}
    // console.log(props.match)
    if (props && props.match && props.match.params && props.match.params.id) {
      rowData["_id"] = JSON.parse(props.match.params.id)
      return rowData
    }
  }
  getTableFields = () => {
    let { languageData } = this.state
    let roleTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Admin',
        value: 'Admin'
      },
      {
        label: 'Super Admin',
        value: 'Super Admin'
      },
      {
        label: 'User',
        value: 'User'
      },
    ];
    let StatusTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      }
    ];
    let data = [
      // {
      //   "textAlign": "center",
      //   "width": 47,
      //   "field": "Check Box",
      //   "label": "Check Box",
      //   "fieldType": "multiple",
      //   "header": "",
      //   "selectionMode": "multiple",
      //   "show": true,
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "textAlign": "center",
        "width": 47,
        "field": "Sno",
        "label": "SNo",
        "header": "SNo",
        "filter": false,
        "sortable": false,
        "placeholder": "Search",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "name",
        "type": "text",
        "placeholder": "Name",
        "label": "Name",
        "header": "Name",
        "width": 110,
        "id": "name",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "textAlign": "Center",
        "globalSearchField": "true",
        "show": true,
        "field": "name",
        "mobile": true,
        "displayInSettings": true,
        "filter":true,
        "sortable": true 
      },
      {
        "name": "date",
        "type": "date",
        "placeholder": "Date",
        "label": "Date",
        "header": "Date",
        "width": 110,
        "id": "date",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,        
        "textAlign": "Center",
        "globalSearchField": "true",
        "show": true,
        "field": "date",
        "mobile": true,
        "displayInSettings": true,
        "fieldType":"date",
        "filter":true,
        "dateFormat": "YYYY-MM-DD",
        "sortable": true 
      },
      
      {
        "name": "modalities",
        "type": "dropDown",
        "placeholder": "modalities",
        "label": "Scan Type",
        "header": "Modalities",
        "width": 110,
        "id": "modalities",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,       
        "textAlign": "Center",
        "globalSearchField": "true",
        "show": true,
        "field": "modalities",
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "dropDown",
        "filterElement": [
          {
            "label": 'MRI',
            "value": 'MRI'

          },
          {
            "label": 'MRA',
            "value": 'MRA'

          },
          {
            "label": 'CT',
            "value": 'CT'

          },
          {
            "label": 'CTA',
            "value": 'CTA'

          },
          {
            "label": 'PET',
            "value": 'PET'

          },
          {
            "label": 'US',
            "value": 'US'
          }


        ],
        "filter":true,
        "sortable": true 
      },
      {
        "name": "scanTime",
        "type": "text",
        "placeholder": "Duration",
        "label": "Duration",
        "header": "Duration",
        "width": 110,
        "id": "scanTime",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "text",
        "textAlign": "Center",
        "globalSearchField": "true",
        "show": true,
        "field": "scanTime",
        "mobile": true,
        "displayInSettings": true,
        "fieldType":"text",
        "filter":true,
        "sortable": true 
      },
      {
        "name": "fromTime",
        "type": "text",
        "placeholder": "From Time",
        "label": "From Time",
        "header": "From Time",
        "width": 110,
        "id": "fromTime",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "text",
        "textAlign": "Center",
        "globalSearchField": "true",
        "show": true,
        "field": "fromTime",
        "mobile": true,
        "displayInSettings": true,
        "fieldType":"text",
        "filter":true,
        "sortable": true 
      },
      {
        "name": "toTime",
        "type": "text",
        "placeholder": "To Time",
        "label": "To Time",
        "header": "To Time",
        "width": 110,
        "id": "toTime",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "text",
        "textAlign": "Center",
        "globalSearchField": "true",
        "show": true,
        "field": "toTime",
        "mobile": true,
        "displayInSettings": true,
        "fieldType":"text",
        "filter":true,
        "sortable": true 
      },
      {
        "name": "isBooked",
        "type": "dropDown",
        "placeholder": "Slot Booked",
        "label": "Slot Booked",
        "header": "Slot Booked",
        "width": 110,
        "id": "isBooked",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Bool",
        "textAlign": "Center",
        "show": true,
        "field": "isBooked",
        "mobile": true,
        "displayInSettings": true,
        
        "filterElement": [
          {
            "label": 'True',
            "value": true
            
          },
          {
            "label": 'False',
            "value": false
            
          }
         
        ],
        filter:true,
        "sortable": true
      },

      {
        "name": "createdByName",
        "type": "Text",
        "placeholder": "Created By",
        "label": "Created By",
        "width": 120,
        "header": "Created By",
        "id": "createdByName",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "field": "createdByName",
        "mobile": true,
        "filter": true,
        "displayInSettings": true
      },
      {
        "name": "updatedByName",
        "type": "Text",
        "placeholder": "Updated By",
        "label": "Updated By",
        "width": 120,
        "header": "Updated By",
        "id": "updatedByName",
        "displayinlist": "true",
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "filter": true,
        "field": "updatedByName",
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": 90,
        "header": "Created",
        "derivedValue": "created=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,        
        "dateFormat": "YYYY-MM-DD HH:mm",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "created",
        "mobile": true,
        "displayInSettings": true,
        "filter":true,
        "fieldType": "date",
        "sortable": true 
      },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": 90,
        "header": "Updated",
        "derivedValue": "updated=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "updated",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "fieldType": "Date",
        "dateFormat": "YYYY-MM-DD HH:mm",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "updated",
        "mobile": true,
        "displayInSettings": true,
        "filter":true,
        "sortable": true 
      }
    ]
    return data;
  };

  getFormFields = () => {
    let { languageData } = this.state
    let statusTypes = [
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      },
    ];
    return ([
      {
        "name": "date",
        "type": "date",
        "placeholder": "Date",
        "label": "Date",
        "width": 110,
        "id": "date",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "globalSearchField": "true",
        "show": true,
        "mobile": true,
        // "minDate":new Date(),
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "gridTake":3,
        
      },
      // {
      //   "name": "toDate",
      //   "type": "date",
      //   "placeholder": "To Date",
      //   "label": "To Date",
      //   "width": 110,
      //   "id": "toDate",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "controllerName": null,
      //   "fieldType": "Link",
      //   "globalSearchField": "true",
      //   "show": true,
      //   "mobile": true,
      //   "displayInSettings": true,
      //   "isAddFormHidden": false,
      //   "isEditFormHidden": false,
      //   "gridTake":3,
      //   "minDate":new Date(),
      //   "maxDate":moment().add(7,'days').toDate(),        
      // },
      
      {
        "name": "modalities",
        "type": "dropDown",
        "placeholder": "Scan Type",
        "label": "modalities",
        "width": "90px",       
        "derivedValue": "status=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "status",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "options": [
          {
            "label": 'MRI',
            "value": 'MRI'

          },
          {
            "label": 'MRA',
            "value": 'MRA'

          },
          {
            "label": 'CT',
            "value": 'CT'

          },
          {
            "label": 'CTA',
            "value": 'CTA'

          },
          {
            "label": 'PET',
            "value": 'PET'

          },
          {
            "label": 'US',
            "value": 'US'
          }


        ],
        "fieldType": "dropDown",
        "filterElement": [
          {
            "label": 'MRI',
            "value": 'MRI'

          },
          {
            "label": 'MRA',
            "value": 'MRA'

          },
          {
            "label": 'CT',
            "value": 'CT'

          },
          {
            "label": 'CTA',
            "value": 'CTA'

          },
          {
            "label": 'PET',
            "value": 'PET'

          },
          {
            "label": 'US',
            "value": 'US'
          }


        ],
        "dependent": [],
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,       
        "isMultiSelect":false,
        "gridTake":3
      },
      {
        "name": "scanTime",
        "type": "dropDown",
        "placeholder": "Scan Duration",
        "label": "Scan Duration",
        "width": "90px",       
        "derivedValue": "status=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "status",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "options": [
          {
            "label": '5 Min',
            "value": '5'
            
          },
          {
            "label": '10 Min',
            "value": '10'
            
          },
          {
            "label": '15 Min',
            "value": '15'
            
          },
          {
            "label": '20 Min',
            "value": '20'
            
          },
          {
            "label": '25 Min',
            "value": '25'
            
          },
          {
            "label": '30 Min',
            "value": '30'
            
          },
          {
            "label": '45 Min',
            "value": '45'
            
          },
          {
            "label": '60 Min',
            "value": '60'
            
          },
          {
            "label": '75 Min',
            "value": '75'            
          },
          {
            "label": '90 Min',
            "value": '90'
            
          },
          {
            "label": '105 Min',
            "value": '105'
            
          },
          {
            "label": '120 Min',
            "value": '120'
            
          }

        ],
        "fieldType": "dropDown",
        "filterElement": [
          {
            "label": '5 Min',
            "value": 5
            
          },
          {
            "label": '10 Min',
            "value": 10
            
          },
          {
            "label": '15 Min',
            "value": 15
            
          },
          {
            "label": '20 Min',
            "value": 20
            
          },
          {
            "label": '25 Min',
            "value": 25
            
          },
          {
            "label": '30 Min',
            "value": 30
            
          },
          {
            "label": '45 Min',
            "value": 45
            
          },
          {
            "label": '60 Min',
            "value": 60
            
          },
          {
            "label": '75 Min',
            "value": 75            
          },
          {
            "label": '90 Min',
            "value": 90
            
          },
          {
            "label": '105 Min',
            "value": 105
            
          },
          {
            "label": '120 Min',
            "value": 120
            
          }
         
        ],
        "dependent": [],
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,        
        "isMultiSelect":false,
        "gridTake":3
      },
      // {
      //   "name": "days",
      //   "type": "dropDown",
      //   "placeholder": "Days",
      //   "label": "Days",
      //   "width": "90px",       
      //   "derivedValue": "status=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": true,
      //   "filter": true,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "status",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "true",
      //   "required": true,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "options": [
      //     {
      //       "label": moment().format("ddd, D MMM  YYYY"),
      //       "value": moment().format(config.dateDBFormat)
            
      //     }
      //   ],
      //   "fieldType": "dropDown",
      //   "filterElement": [
      //     {
      //       "label": moment().format("ddd, D MMM  YYYY"),
      //       "value": moment().format(config.dateDBFormat)
            
      //     }
         
      //   ],
      //   "dependent": [],
      //   "show": true,
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true,
      //   "isAddFormHidden": false,
      //   "isEditFormHidden": false,
      //   "defaultValue": {
      //     "label": "Created",
      //     "value": "Created",
      //     "color": "primary"
      //   },
      //   "isMultiSelect":true,
      //   "gridTake":3
      // },
      {
        "name": "fromTime",
        "type": "time",
        "placeholder": "From Time",
        "label": "From Time",
        "width": 110,
        "id": "fromTime",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "globalSearchField": "true",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "gridTake":3,
        "required":true
      },
      {
        "name": "toTime",
        "type": "time",
        "placeholder": "To Time",
        "label": "To Time",
        "width": 110,
        "id": "toTime",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "globalSearchField": "true",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "gridTake":3,
        "required":true
      },
      // {
      //   "name": "breakStartTime",
      //   "type": "time",
      //   "placeholder": "Break Start",
      //   "label": "Break Start",
      //   "width": 110,
      //   "id": "breakStartTime",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "controllerName": null,
      //   "fieldType": "Link",
      //   "globalSearchField": "true",
      //   "show": true,
      //   "mobile": true,
      //   "displayInSettings": true,
      //   "isAddFormHidden": false,
      //   "isEditFormHidden": false,
      //   "gridTake":3,
      //   "required":true
      // },
      // {
      //   "name": "breakEndTime",
      //   "type": "time",
      //   "placeholder": "Break Ends",
      //   "label": "Break Ends",
      //   "width": 110,
      //   "id": "breakEndTime",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "controllerName": null,
      //   "fieldType": "Link",
      //   "globalSearchField": "true",
      //   "show": true,
      //   "mobile": true,
      //   "displayInSettings": true,
      //   "isAddFormHidden": false,
      //   "isEditFormHidden": false,
      //   "gridTake":3,
      //   "required":true
      // },
      {
        "name": "createdBy",
        "type": "relateAutoComplete",
        "placeholder": "CreatedBy",
        "label": "CreatedBy",
        "width": 90,
        "disabled": true,
        "derivedValue": "createdBy=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "createdBy",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "searchField": "name",
        "fieldType": "relateAutoComplete",
        "controllerName": "employee",
        "searchApi": "employees",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "updatedBy",
        "type": "relateAutoComplete",
        "placeholder": "UpdatedBy",
        "label": "UpdatedBy",
        "width": 90,
        "derivedValue": "updatedBy=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "updatedBy",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "searchField": "name",
        "disabled": true,
        "fieldType": "relateAutoComplete",
        "controllerName": "employee",
        "searchApi": "employees",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": 90,
        "derivedValue": "created=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "fieldType": "Date",
        "dateFormat": "YYYY-MM-DD HH:mm:ss",
        "disabled": true,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": 90,
        "derivedValue": "updated=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "updated",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "fieldType": "Date",
        "dateFormat": "YYYY-MM-DD HH:mm:ss",
        "disabled": true,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      }
    ]);
  }

  submit = async (item) => {

    this.setState({ isOpenFormModal: true })
    await this.formModalRef.getRowData(item, 'edit');

    console.log("Submit Button in sode          ")
  }
  getMobileTableFields = () => {
    let data = [{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"name","type":"text","placeholder":"Name","label":"Name","header":"Name","width":110,"id":"name","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"fieldType":"Link","textAlign":"Center","globalSearchField":"true","show":true,"field":"name","mobile":true,"displayInSettings":true},{"name":"createdBy","type":"relateAutoComplete","placeholder":"CreatedBy","label":"CreatedBy","width":90,"disabled":true,"header":"CreatedBy","derivedValue":"createdBy=undefined","actions":[],"actionsNumber":[],"id":"createdBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"createdBy","mobile":true,"displayInSettings":true},{"name":"updatedBy","type":"relateAutoComplete","placeholder":"UpdatedBy","label":"UpdatedBy","width":90,"header":"UpdatedBy","derivedValue":"updatedBy=undefined","actions":[],"actionsNumber":[],"id":"updatedBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","disabled":true,"fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"updatedBy","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true}]

    return data;
  };
  closeFormModal = async () => {
    this.setState({
      isOpenFormModal: false,
    })
  }
  // submit1 = item => {
  //   let x = slotssFields
  //   let objslotss = {}

  //   objslotss["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objslotss[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objslotss,
  //     newFormFields: formFields
  //   });
  // }
  
  cancelReset = async (type) => {
    this.setState({
      openNewUserModal: false
    });
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };
  saveDataToServer = async (item, field, value) => {
    // console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAa", item, field, value)
    let body = item[0]
    body[field] = value
    let userBody = Object.assign({}, body);
    this.setState({
      isLoading: true
    });
    if (body) {
      let method, apiUrl;
      method = 'PUT';
      apiUrl = `${apiCalls.slotss}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, 'success');

          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, 'error');
          }
          this.setState({
            isLoading: false
          });
        }).catch((err) => {
          return err;
        });
    } else {
      return;
    }
  }
  render() {
    return (
      <span>        
        <DataTables
          {...this.props}
          onRef={ref => (this.dataTableRef = ref)}
          // MobileTableFields={this.getMobileTableFields}
          // getTableFields={this.getTableFields}
          // formFields={this.getFormFields}
          // 
addRequired={false}
editRequired={ false}
deleteRequired={false}
viewRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
exportRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
sample={true}
          // globalSearch={'Display Name/Email'}
          // type='Slotss'
          // apiUrl={apiCalls.Slotss}
          getTableFields={this.getTableFields}
          formFields={this.getFormFields}
          // exportRequried={true}

          printRequried={true}
          actionsTypes={[
            // {
            //   'name': 'Delete',
            //   "options": [
            //     { 'label': 'Delete', 'value': 'Delete', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": true, },
            //   ]
            // },
            
            // {
            //   'name': 'Block',
            //   "options": [
            //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
            //   ]
            // },
            // {
            //   'name': 'ResetPassword',
            //   "options": [
            //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
            //   ]
            // },
            // {
            //   'name': 'Submit',
            //   'action': this.submit,
            //   "options": [
            //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
            //   ]
            // },
            // {
            //   name: "newModel",
            //   action: this.submit1,
            //   options: [
            //     { label: "newModel", value: "newModel", show: true, multiple: false }
            //   ]
            // }
            
          ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={true}
          exportToCsv={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          sampleFilePath={filePath.Slotss}
          setData={this.setData}
          editSelectedRecord={false}
          addSelectedRecord={false}
          viewSelectedRecord={this.state.viewSelectedRecord}
          globalSearch={'name'}
          type='Slots'
          routeTo={apiCalls.Slotss}
          displayViewOfForm='screen'
          apiResponseKey={apiCalls.Slotss}
          apiUrl={apiCalls.Slotss}

        />
        {this.state.isOpenFormModal ? (
          <FormModal
            onRef={(ref) => (this.formModalRef = ref)}
            formType="edit"
            openFormModal={this.state.isOpenFormModal}
            formFields={this.props.formFields}
          />

        ) : null}
        {this.state.openNewUserModal ? (
          <NewUserModal
            openNewUserModal={this.state.openNewUserModal}
            cancelReset={this.cancelReset}
            item={this.state.item}
            newFormFields={this.state.newFormFields}
            recordId={this.state.item._id}
            entityType="slotss"
            apiUrl={apiCalls.Slotss}
          />
        ) : null}
      </span>
    );
  }
}